/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Error_Somethingwentwrong2Inputs */

const en_common_error_somethingwentwrong2 = /** @type {(inputs: Common_Error_Somethingwentwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong, please try again`)
};

/**
* | output |
* | --- |
* | "Something went wrong, please try again" |
*
* @param {Common_Error_Somethingwentwrong2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_error_somethingwentwrong2 = /** @type {((inputs?: Common_Error_Somethingwentwrong2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Error_Somethingwentwrong2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_error_somethingwentwrong2(inputs)
});
export { common_error_somethingwentwrong2 as "common_error_somethingWentWrong" }